<template>
    <div>
        <div class="page-container" v-loading="loading">
            <el-collapse
                v-model="activeName"
                @change="
                    (e) => {
                        showSearchParams = e.length > 0
                    }
                "
            >
                <el-collapse-item name="1">
                    <template slot="title">
                        <span v-show="!showSearchParams" @click="showSearchParams = !showSearchParams"
                            >{{ $t('show_confirmation_overview') }}<i class="el-icon-arrow-down"></i
                        ></span>
                        <span v-show="showSearchParams" @click="showSearchParams = !showSearchParams"
                            >{{ $t('hide_confirmation_overview') }}<i class="el-icon-arrow-up"></i
                        ></span>
                    </template>
                    <div class="summary">
                        <div
                            :class="[
                                'summary-item',
                                activeSummary === v.id ? 'active' : '',
                                showConfirmationReplyStatus ? 'summary-item-small' : '',
                                updateGuide && updateGuideStep === 1 && v.id == 2 ? 'updateGuideIcon' : ''
                            ]"
                            v-for="v in summary.filter((vv) => (showConfirmationReplyStatus ? true : ![5, 6].includes(vv.id)))"
                            :key="v.id"
                            @click="filterStatus(v)"
                        >
                            <div class="summary-item-value">{{ v.value }}</div>
                            <div :class="['summary-item-title', $i18n.locale === 'en' ? 'en-cls' : '']" v-html="v.title"></div>
                            <div class="updateGuideTip" v-if="updateGuide && updateGuideStep === 1 && v.id == 2">
                                <div class="margin-bottom-10">1/5</div>
                                <div class="margin-bottom-10">{{ $t('confirmation_bubble_1') }}</div>
                                <el-button @click="nextClick" class="guide-btn">{{ $t('next') }}</el-button>
                            </div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <DetailTable
                ref="detailTable"
                :activeSummary.sync="activeSummary"
                :loading.sync="loading"
                :class="['detail-info-container', showSearchParams ? 'show-params' : '']"
                :showSearchParams="showSearchParams"
                :getOverviewData="getOverviewData"
                :updateGuide="updateGuide"
                :updateGuideStep="updateGuideStep"
                :nextClick="nextClick"
            />
        </div>
    </div>
</template>
<script>
import API from '@/api'
import DetailTable from './DetailTable'
import { loading } from '@/utils'
import { mapGetters } from 'vuex'

export default {
    name: 'Detaillist',
    components: { DetailTable },
    props: {
        updateGuide: Boolean,
        updateGuideStep: Number,
        nextClick: Function
    },
    data() {
        return {
            activeName: '1',
            showSearchParams: true,
            summary: [
                {
                    id: 1,
                    icon: require('@/assets/img/icon-draft.svg'),
                    title: this.$t('confirmation_status._1'),
                    value: 0
                },
                {
                    id: 2,
                    icon: require('@/assets/img/icon-pending-for.svg'),
                    title: `<span style="color: #fd349c">` + this.$t('confirmation_status._2') + `</span>`,
                    value: 0
                },
                {
                    id: 3,
                    icon: require('@/assets/img/icon-authorised.svg'),
                    title: this.$t('confirmation_status._3'),
                    value: 0
                },
                {
                    id: 4,
                    icon: require('@/assets/img/icon-authorisation-completed.svg'),
                    title: this.$t('confirmation_status._4'),
                    value: 0
                },
                {
                    id: 5,
                    icon: require('@/assets/img/icon-authorisation-completed.svg'),
                    title: this.$t('confirmation_status._5'),
                    value: 0
                },
                {
                    id: 6,
                    icon: require('@/assets/img/icon-authorisation-completed.svg'),
                    title: this.$t('confirmation_status._6'),
                    value: 0
                },
                {
                    id: 7,
                    icon: require('@/assets/img/icon-total.svg'),
                    title: this.$t('total'),
                    value: 0
                }
            ],
            activeSummary: null,
            videoTipImg: require('@/assets/img/kpicon-video.svg'),
            loading: false,
            showConfirmationReplyStatus: false
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite'
        })
    },
    async mounted() {
        await this.getTileGeneral()
        await this.getOverviewData()
         
        if(this.$route.query.homeFilterStatus){
            // this.filter.status.multiCheck = [this.$route.query.homeFilterStatus]
            this.filterStatus(this.summary[+this.$route.query.homeFilterStatus - 1])
        }
    },
    methods: {
        changeGuideTitleHeight() {
            this.$refs.detailTable.changeGuideTitleHeight()
        },
        async getTileGeneral() {
            const _loading = loading()
            _loading.load()
            return API.general
                .siteTilesGeneral({ siteId: this.getSite.siteId })
                .then((res) => {
                    if (res.code == '1') {
                        this.showConfirmationReplyStatus = res.data.showConfirmationReplyStatus
                    }
                })
                .finally(() => {
                    _loading.close()
                })
        },
        filterStatus(item) {
             
             
            if (this.activeSummary === item.id) {
                this.$refs.detailTable.clearFilter()
            } else {
                this.activeSummary = item.id
                this.$refs.detailTable.activeSummaryChange(item.id)
            }
        },
        /**
         * 获取顶部五个大卡片的数据
         */
        getOverviewData() {
            let params = {
                siteId: this.getSite.siteId,
                entityId: [],
                confirmationTypeKcc: [],
                userSetOverdueDays: 5
            }
            API.confirmation.getDashboard(params).then((res) => {
                if (res.code === '1') {
                    let dataList = this.showConfirmationReplyStatus
                        ? res.data.confirmationByEntityAndStatusSubBOList
                        : res.data.confirmationByEntityAndStatusBOList
                    let draft = 0
                    let pendingFor = 0
                    let sentToKPMG = 0
                    let completed = 0
                    let status5 = 0
                    let status6 = 0
                    if (dataList && dataList.length > 0) {
                        dataList.forEach((item) => {
                            draft += item.draftNum || 0
                            pendingFor += item.pendingForClientAuthorisationNum || 0
                            sentToKPMG += item.authorisedConfirmationSentToKPMGNum || 0
                            completed += item.authorizationCompletedNum || 0
                            if (this.showConfirmationReplyStatus) {
                                status5 += item.confirmationsReceivedAndProcessedByAddresseesNum || 0
                                status6 += item.confirmationsReceivedFromAddresseesNum || 0
                            }
                        })
                    }
                    this.summary[0].value = draft
                    this.summary[1].value = pendingFor
                    this.summary[2].value = sentToKPMG
                    this.summary[3].value = completed
                    if (this.showConfirmationReplyStatus) {
                        this.summary[4].value = status5
                        this.summary[5].value = status6
                        this.summary[6].value = draft + pendingFor + sentToKPMG + completed + status5 + status6
                    } else {
                        this.summary[6].value = draft + pendingFor + sentToKPMG + completed
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        }
    },
    watch: {
        showConfirmationReplyStatus(v) {
            // this.getOverviewData()
        }
    }
}
</script>
<style scoped>
.page-container {
    background-color: #fff;
    padding: 6px 15px 0 15px;
    border-radius: 5px;
    height: 100%;
}
::v-deep .el-collapse-item__header {
    height: 35px;
    line-height: 35px;
    width:50% !important;
}
::v-deep .el-collapse-item__content {
    padding-bottom: 8px;
}

::v-deep .el-collapse-item__arrow {
    visibility: hidden !important;
}
.summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.summary .summary-item {
    width: calc((100% - 90px) / 5);
    height: 125px;
    border-radius: 10px;
    padding-right: 5px;
    border: 1px solid #eee;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.summary .summary-item-small {
    width: calc((100% - 90px) / 7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}


.summary .summary-item.active {
    border: 1px solid #3879eb;
    box-shadow: 0 0 15px rgba(56, 121, 235, 0.2);
    background-image: url('~@/assets/img/sy-btcheck.svg');
    background-size: 35px 35px;
    background-position: top right;
    background-repeat: no-repeat;
}

.summary .summary-item .summary-item-title {
    font-size: 22px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    /* flex: 1; */
    word-break: break-word;
    
}

.summary .summary-item-small .summary-item-title {
    font-size: 18px;
}
.summary .summary-item .en-cls {
    font-size: 16px;
}

.summary .summary-item .summary-item-value {
    margin-right: 5px;
    font-size: 32px;
    font-weight: bold;
    color: #3879eb;
    text-align: right;
    min-width: 40px;
}
.detail-info-container {
    margin-top: 8px;
    height: calc(100% - 43px);
}
.detail-info-container.show-params {
    height: calc(100% - 175px);
}
.updateGuideIcon {
    height: 24px;
    width: 24px;
    z-index: 101;
    border: 2px solid #3879eb !important;
    border-radius: 10px;
    position: relative;
    background-color: white;
}
.updateGuideIcon .updateGuideTip {
    position: absolute;
    z-index: 101;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    right: -250px;
    top: 0;
    width: 240px;
    border-radius: 10px;
    line-height: normal;
    font-size: 14px;
    line-height: normal;
}
.margin-bottom-10 {
    margin-bottom: 10px;
}
.guide-btn {
    float: right;
    color: #3879eb;
}
::v-deep .el-collapse-item__wrap {
    overflow: visible;
}
</style>
